module.exports = __webpack_public_path__ + "img/bg1 (4).ae3dfb56.jpg";